@if (charityPageData$ | async; as charityInfo) {
  @if (userBalanceDetails$ | async; as balance) {
  <div class="charitycard-wrapper">
    <ion-card>
      <h2 class="card-title">
        {{
        charityInfo?.content[data]?._charity_name && charityInfo?.content[data]?._charity_name[selectedLanguage]
        ? charityInfo?.content[data]?._charity_name[selectedLanguage]
        : charityInfo?.content[data]?.charity_name
        }}
      </h2>
      <img class="big-card-image" src="{{ charityInfo?.content[data]?.charity_image }}" />
      <ion-card-header class="ion-card-header">
        <img src="{{ charityInfo?.content[data]?.charity_logo }}" />
      </ion-card-header>
      <ion-card-content
        >{{
        charityInfo?.content[data]?._charity_long_description &&
        charityInfo?.content[data]?._charity_long_description[selectedLanguage]
        ? charityInfo?.content[data]?._charity_long_description[selectedLanguage]
        : charityInfo?.content[data]?.charity_long_description
        }}
        <ion-button
          class="purple-btn"
          (click)="charityVote(charityInfo?.content, data); startSpinner(charityInfo?.content, data)"
          [disabled]="isVoteDisabled || balance?.points < 10"
          >
          @if (!charityInfo?.content[data]?.spinner?.spinnerAnimation && charityInfo?.content[data]?.spinner?.proceed) {
            <span
              >{{
              buttonLabel || (charityInfo?.content[data]?._button_label && charityInfo?.content[data]?._button_label[selectedLanguage]
              ? charityInfo?.content[data]?._button_label[selectedLanguage]
              : charityInfo?.content[data]?.button_label)
              }}</span
              >
            }
            @if (charityInfo?.content[data]?.spinner?.spinnerAnimation) {
              <div class="spinners">
                <mat-progress-spinner
                  class="spinner-circle"
                  mode="determinate"
                  [value]="charityInfo?.content[data].spinner.progressBar"
                  diameter="40"
                  >
                </mat-progress-spinner>
              </div>
            }
            @if (!charityInfo?.content[data]?.spinner?.proceed) {
              <mat-icon class="tick-mark">done </mat-icon>
            }
          </ion-button>
        </ion-card-content>
      </ion-card>
    </div>
    }
  }
